import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

const GET_ALL_DESIGNER_ACCOUNTS_QUERY = gql`
  query GetAllDesignerAccounts {
    getAllDesignerAccounts {
      _id
      designerId {
        _id
        firstName
        lastName
        aliasId
        email
        accountType
        businessName
        businessAddress
        businessCity
        businessState
        businessZipCode
        phoneNumber
        emailVerified
      }
      experience {
        id
        title
        company
        startDate
        endDate
        current
        employmentType
        firmSize
      }
      education
      references {
        id
        type
        businessName
        firstName
        lastName
        title
        ProjectType
        email
        phoneNumber
        startDate
        endDate
        yearsKnown
      }
      businessGoals {
        overview {
          numberOfProjectsLastYear
          totalRevenueLastYear
          numberOfProjectsCurrentYear
          totalRevenueCurrentYear
        }
        projectCapacity {
          largeScale
          smallScale
        }
        challenges
        expectations
      }
      status
      membershipTier
      createdAt
      updatedAt
      submittedAt
    }
  }
`;

export const useGetAllDesignerAccountsQuery = () => {
  const [getAllDesignerAccountsQuery, { loading, error, data }] =
    useLazyQuery(GET_ALL_DESIGNER_ACCOUNTS_QUERY, {
      fetchPolicy: "network-only",
    });

  const getAllDesignerAccounts = useCallback(
    async (refresh: boolean = false) => {
      console.log("🔍 Executing GraphQL query: getAllDesignerAccounts");
      try {
        const result = await getAllDesignerAccountsQuery();
        console.log("📊 GraphQL result:", result);
        console.log("📊 GraphQL data:", result.data);
        console.log("📊 GraphQL errors:", result.errors);
        return result.data?.getAllDesignerAccounts ?? [];
      } catch (error) {
        console.error("❌ GraphQL query failed:", error);
        throw error;
      }
    },
    [getAllDesignerAccountsQuery]
  );

  return {
    getAllDesignerAccounts,
    loading,
    error,
    data,
  };
};
